import React from "react";
import AddDepoistAmount from "./components/addDepositAmount";
import TableDepoistAmount from "./components/tableDepositAmount";
import PrimaryHeading from "components/heading/PrimaryHeading";
import SecondaryHeading from "components/heading/SecondaryHeading";
import useAxiosInstance from "../../../axiosInstance";
import Loading from "components/loading";
import { toast } from "react-toastify";

const DepoistAmount = () => {
  const [data, setData] = React.useState([]);
  const axiosInstance = useAxiosInstance();
  const [isLoading, setIsLoading] = React.useState(false);

  if (isLoading === true) {
    return (
      <div className="flex h-screen flex-col items-center justify-center">
        <div className="flex items-center justify-center">
          <Loading />
        </div>
      </div>
    );
  }
  return (
    <div>
      <PrimaryHeading title={"Add Rent Amount"} />
      <AddDepoistAmount />
      <SecondaryHeading title={"Rent Amounts"} />
      {<TableDepoistAmount data={data} />}
    </div>
  );
};

export default DepoistAmount;
